import React from "react";
import { Button } from "../ui/button";
import { Zap, ShieldCheck, PoundSterling, FileCheck, ArrowRight } from "lucide-react";
import { MAIN_APP_URL } from "../../lib/config";

const BENEFITS = [
  {
    icon: Zap,
    title: "Quick collection often possible, depending on carrier availability",
    body: "Carriers respond fast when you're on Binshare.",
  },
  {
    icon: ShieldCheck,
    title: "Registered waste carriers only",
    body: "Carriers are checked against the official waste carrier register for their area.",
  },
  {
    icon: PoundSterling,
    title: "Transparent pricing — no surprises",
    body: "Fixed quotes upfront. Confirm the price you like. No hidden add-ons on collection day.",
  },
  {
    icon: FileCheck,
    title: "Duty-of-care receipt for every job",
    body: "A digital receipt for every job, generated automatically.",
  },
];

export default function ForCustomers() {
  return (
    <section
      id="for-customers"
      className="py-24 md:py-32 bg-cream-50"
      data-testid="for-customers"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-[11px] font-semibold tracking-[0.18em] uppercase text-sage-700">
            For customers
          </p>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold text-moss-950 leading-[1.02] text-balance">
            Fast, trusted,{" "}
            <span className="text-sage-600">guaranteed.</span>
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-6 lg:gap-8">
          {BENEFITS.map((b) => {
            const Icon = b.icon;
            return (
              <div
                key={b.title}
                className="rounded-3xl bg-white border border-moss-100 p-6 lg:p-8 hover:border-sage-200 hover:shadow-lg hover:shadow-moss-900/5 transition-all"
                data-testid={`customer-benefit-${b.title.toLowerCase().split(" ").slice(0, 2).join("-")}`}
              >
                <div className="w-12 h-12 rounded-xl bg-sage-100 text-sage-800 flex items-center justify-center">
                  <Icon className="w-6 h-6" strokeWidth={2.25} />
                </div>
                <h3 className="font-display mt-5 text-xl font-bold text-moss-950 leading-tight">
                  {b.title}
                </h3>
                <p className="mt-2 text-moss-700 leading-relaxed">
                  {b.body}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-14">
          <a
            href={MAIN_APP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="customer-post-job-cta"
          >
            <Button className="h-14 px-8 rounded-full bg-moss-900 hover:bg-moss-950 text-cream-50 text-base font-bold shadow-lg shadow-moss-900/20">
              Post your job now
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}
